/** @typedef {import('../types/entity/TrimIndexData').TrimIndexData} TrimIndexData */
/** @typedef {import('../types/dto/GeoPointDTO').GeoPointDTO} GeoPointDTO */

import { findInDirectTimestamp, findInPolyline } from './multiSportUtils';

/**
 * @param {{
 *  timestamp: number;
 *  directTimestamp: number[];
 *  polyline: GeoPointDTO[];
 * }} param0
 * @returns {TrimIndexData}
 */
export const createTrimIndexData = ({ timestamp, directTimestamp, polyline }) => {
    const { index: metricsStartIdx, isExactMatch } = findInDirectTimestamp(directTimestamp, timestamp);
    const { index: polylineStartIdx } = findInPolyline(polyline, timestamp);
    return {
        metricsStartIdx,
        timestamp: isExactMatch ? null : timestamp,
        polylineStartIdx
    };
};
